<template>
  <v-container
    class="twilio-whatsapp-shell textoPoppins pa-0"
    fluid
    @keydown.ctrl="abrirPegar"
    v-if="[2714, 2035, 2715, 1 , 334, 3015 , 718 , 2574 , 568, 1794,2230,954,2328, 2268,2230,1312, 2910, '2910', 3042].includes(getdatosUsuarioERPERP.iderp) || getdatosUsuarioERPERP.idpuesto == 19 || getdatosUsuarioERPERP.idpuesto == 18"
  >
    <v-card class="twilio-whatsapp-app elevation-6">
      <v-row class="ma-0 fill-height twilio-whatsapp-row">
        <v-col
          cols="12"
          sm="6"
          class="pa-0 twilio-whatsapp-sidebar"
          :class="{ 'wa-panel-hidden': isMobileLayout && chat }"
        >
          <Toolbar
            :whatsapp-style="true"
            :nameTwilio="'CRM ALUMNOS FAST'"
            :vendedorasTwilio="vendedorasTwilio"
            :filtroVendedora="filtroVendedora"
            :vendedoras_plantel="vendedoras_plantel"
            @seleccionaVendedora="seleccionaVendedora"
            @initialize="initializeAllCities()"
            @abrirAjustesMensajes="abrirAjustesMensajes"
            @emitUsersChats="getUsersChats()"
            @emitOnlyMychats="seleccionaVendedora()"
            :cantidadChats="filterChats.length"
            :tiempoCargaMs="tiempoCargaMs"
            :alumnos="alumnos"
            :planteles="planteles"
            :filterChats="filterChats"
          />

          <div class="wa-search-panel">
            <v-text-field
              :readonly="filterChats ? false : true"
              v-model="buscarUsuario"
              hide-details
              dense
              solo
              flat
              clearable
              rounded
              :autofocus="buscarUsuarioActive"
              prepend-inner-icon="mdi-magnify"
              placeholder="Buscar o iniciar un chat"
              class="wa-search"
            ></v-text-field>

            <div class="wa-filter-row wa-filter-row--stacked">
              <v-autocomplete
                class="wa-select wa-incompletos-select"
                :items="plantelesConContactos"
                v-model="plantel"
                label="Plantel"
                item-value="idplantel"
                item-text="texto"
                dense
                hide-details
                solo
                flat
                rounded
                clearable
              ></v-autocomplete>

              <v-autocomplete
                class="wa-select wa-incompletos-select"
                :items="gruposOnline"
                v-model="grupoOnline"
                label="Grupo online"
                item-value="id_grupo"
                item-text="grupo"
                dense
                hide-details
                solo
                flat
                rounded
                clearable
              ></v-autocomplete>
            </div>

            <div class="wa-filter-row">
              <v-btn fab small class="wa-filter-btn" :color="filtroVistos ? 'grey darken-2' : 'white'" @click="filtroVistos = !filtroVistos">
                <v-icon :color="filtroVistos ? 'white' : 'grey darken-2'">mdi-message-bulleted-off</v-icon>
              </v-btn>

              <v-menu bottom offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab small color="white" class="wa-filter-btn" v-bind="attrs" v-on="listenersFiltroMenu('filtroSinAlumno', false, on)">
                    <v-icon :color="filtroSinAlumno ? filtroSinAlumno.color : 'grey darken-2'">mdi-account-off</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    v-for="(item, index) in asignaciones"
                    :key="index"
                    @click="toggleFiltro('filtroSinAlumno', item, 'text', false)"
                  >
                    <v-list-item-title class="text-caption">
                      <v-icon :color="item.color">mdi-label</v-icon>
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-menu bottom offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab small color="white" class="wa-filter-btn" v-bind="attrs" v-on="listenersFiltroMenu('etiqueta', null, on)">
                    <v-icon :color="etiqueta ? etiqueta.color : 'grey darken-2'">mdi-checkbox-blank-circle</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    v-for="(item, index) in etiquetas_inscritos"
                    :key="index"
                    @click="toggleFiltro('etiqueta', item, 'idetiquetas_inscritos')"
                  >
                    <v-list-item-title class="text-caption">
                      <v-icon :color="item.color">mdi-label</v-icon>
                      {{ item.text }} {{ item.count ? '(' + item.count + ')' : '' }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-btn
                rounded
                class="wa-filter-clear"
                @click="filtroRi = null, filtroSinAlumno = false, filtroMensajes = false, filtroHielo = false, filtroFuego = false, filtroVistos = false, etiqueta = null, filtroTiempo = null, filtroVendedora = null, filtroSinProspecto = null, filtroIncompletos = null, filtroCiudad = 'todas', plantel = null, grupoOnline = null"
              >
                Todos!!
              </v-btn>

              <v-btn
                v-if="[1, 32, 334, 3015, 718, 2574, 568,1794,2230,954,1312,2910,'2910'].includes(getdatosUsuarioERPERP.iderp) && alumnos.length > 0"
                fab
                small
                class="wa-filter-btn"
                color="blue"
                dark
                @click="buscarChatsCon2026"
              >
                <v-icon>mdi-filter</v-icon>
              </v-btn>

              <v-menu bottom offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab small color="white" class="wa-filter-btn" v-bind="attrs" v-on="listenersFiltroMenu('filtroTiempo', null, on)">
                    <v-icon :color="filtroTiempo ? filtroTiempo.color : 'grey darken-2'">mdi-clock</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    v-for="(item, index) in tiempos"
                    :key="index"
                    @click="toggleFiltro('filtroTiempo', item, 'idtiempos')"
                  >
                    <v-list-item-title class="text-caption">
                      <v-icon :color="item.color">mdi-clock</v-icon>
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-menu bottom offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab small color="white" class="wa-filter-btn" v-bind="attrs" v-on="listenersFiltroMenu('filtroRi', null, on)">
                    <v-icon :color="filtroRi ? filtroRi.color : 'grey darken-2'">mdi-cash</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    v-for="(item, index) in filstrosRI"
                    :key="index"
                    @click="toggleFiltro('filtroRi', item, 'text')"
                  >
                    <v-list-item-title class="text-caption">
                      <v-icon :color="item.color">mdi-cash</v-icon>
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>

          <ListaAlumnos
            :filterChats="filterChats"
            :whatsapp-style="true"
            :chat-activo="chat"
            @verChat="verChat"
            :limite="limite"
          />
        </v-col>

        <v-col
          cols="12"
          sm="6"
          class="pa-0 twilio-whatsapp-conversation"
          :class="{ 'wa-panel-hidden': isMobileLayout && !chat }"
        >
          <div v-if="!chat" class="wa-empty-state">
            <v-icon size="96" color="#d1d7db">mdi-whatsapp</v-icon>
            <h2>CRM Alumnos Fast</h2>
            <p>Selecciona un chat para ver la conversación en tiempo real.</p>
          </div>

          <template v-else>
            <div class="wa-chat-header">
              <div class="d-flex align-center overflow-hidden">
                <v-btn
                  v-if="isMobileLayout"
                  icon
                  small
                  class="mr-2 wa-back-btn"
                  @click="cerrarChatMobile"
                >
                  <v-icon color="#54656f">mdi-arrow-left</v-icon>
                </v-btn>
                <v-avatar color="#00a884" size="44">
                  <v-icon color="white">mdi-school</v-icon>
                </v-avatar>
                <div class="ml-3 overflow-hidden">
                  <div class="wa-chat-name" v-if="chat.alumno">{{ chat.matricula }} : {{ chat.alumno }}</div>
                  <div class="wa-chat-name" v-else>{{ chat.usuario }}</div>
                  <div class="wa-chat-meta" v-if="chat.grupo">{{ chat.grupo }}</div>
                  <div class="wa-chat-timing" v-if="tiempoCargaChatMs != null">
                    twilio.chats.unico · {{ tiempoCargaChatMs }} ms
                  </div>
                </div>
              </div>

              <div class="wa-chat-actions">
                <v-btn
                  v-if="[1, 32, 334, 3015, 718, 2574, 568,1794,2230,954, 2268,1312,2910,'2910'].includes(getdatosUsuarioERPERP.iderp)"
                  small
                  rounded
                  depressed
                  color="#ffffff"
                  class="wa-action-btn"
                  @click="dialogAsignarAlumno.estatus = true"
                >
                  <v-icon small left>mdi-account-plus</v-icon>
                  Asignar Alumno
                </v-btn>

                <v-btn
                  v-if="![1, 32, 334, 3015, 718, 2574, 568,1794,2230,954, 2268,1312,2910,'2910'].includes(getdatosUsuarioERPERP.iderp) && !chat.alumno"
                  small
                  rounded
                  depressed
                  color="#ffffff"
                  class="wa-action-btn"
                  @click="dialogAsignarAlumno.estatus = true"
                >
                  <v-icon small left>mdi-account-plus</v-icon>
                  Asignar Alumno
                </v-btn>

                <v-btn icon small @click="verCodigoZoom = true">
                  <v-icon color="#54656f">mdi-lock-open</v-icon>
                </v-btn>

                <v-tooltip bottom v-if="chat && chat.alumno && idAlumnoChat">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      small
                      @click="dialogComentariosAlumnoChat = true"
                    >
                      <v-icon color="#54656f">mdi-comment-plus-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Comentarios del alumno</span>
                </v-tooltip>

                <v-menu top offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on">
                      <v-icon color="#54656f">mdi-label-outline</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item
                      v-for="(item, index) in etiquetas_inscritos"
                      :key="index"
                      @click="cambiarCategoriaInscrito(item.idetiquetas_inscritos)"
                    >
                      <v-list-item-title class="text-caption">
                        <v-icon :color="item.color">mdi-label</v-icon>
                        {{ item.text }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>

            <section class="wa-chat-area">
              <v-container
                id="scroll-target"
                v-scroll:#scroll-target="onScroll"
                class="wa-messages-scroll overflow-y-auto elevation-0"
              >
                <div v-if="mensajesCargandoMas" class="text-center py-2">
                  <v-progress-circular indeterminate size="20" width="2" color="primary"></v-progress-circular>
                  <span class="caption grey--text ml-2">Cargando mensajes anteriores…</span>
                </div>
                <MensajesWppTwilio
                  class="messages-chat elevation-0"
                  id="mensajesChat"
                  :whatsappStyle="true"
                  :mensajes="mensajes"
                  :alumno="alumno"
                  :wha="wha"
                  :chat="chat"
                  :verTodosLosMensajes="verTodosLosMensajes"
                  :analysisIA="analysisIA"
                  :asignacion="asignacion"
                  :numeroTwilio="chat.numeroTwilio"
                  @validayGuardaMensajes="validayGuardaMensajes"
                  :chats="allChats"
                  @verChat="verChat"
                />
              </v-container>
            </section>
          </template>
        </v-col>
      </v-row>
    </v-card>

    <v-dialog v-model="dialogDescrip" max-width="500px" transition="dialog-transition">
          <v-card>
            <v-card-title primary-title>
              Etiquetas
            </v-card-title>
            <v-card-text class="black--text">
              <div v-for="(etiqueta, i) in etiquetas">
                <v-icon :color="etiqueta.color">mdi-label</v-icon><b>{{ etiqueta.etiqueta }}</b>
  
                <br />
                {{ etiqueta.detalles }}
  
                <br />
                <br />
                <v-divider></v-divider>
              </div>
  
            </v-card-text>
  
          </v-card>
        </v-dialog>

        <!-- Diálogo para mostrar chats con "2026" en el último mensaje -->
        <!-- Diálogo para mostrar chats con "2026" en el último mensaje -->
        <v-dialog v-model="dialogChats2026" max-width="1200px" transition="dialog-transition">
          <v-card>
            <v-card-title class="text-h6">
              Chats con "2026" en último mensaje del usuario
              <v-spacer></v-spacer>
              <v-btn
                v-if="!cargar"
                color="success"
                dark
                small
                @click="asignarTodos2026"
                class="mr-3"
              >
                <v-icon small left>mdi-check-all</v-icon>
                Asignar Todos
              </v-btn>
              <v-chip color="primary">{{ tablaChats2026.length }}</v-chip>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="headersChats2026"
                :items="tablaChats2026"
                class="elevation-0"
                dense
                :loading="cargar"
                :mobile-breakpoint="0"
              >
                <template v-slot:item.numero="{ item }">
                  {{ item.usuario }}
                </template>
                <template v-slot:item.matricula_extraida="{ item }">
                  {{ item.matricula_extraida || '' }}
                </template>
                <template v-slot:item.id_alumno="{ item }">
                  {{ item.id_alumno || '' }}
                </template>
                <template v-slot:item.matricula="{ item }">
                  {{ item.matricula || '' }}
                </template>
                <template v-slot:item.alumno="{ item }">
                  {{ item.alumno || '' }}
                </template>
                <template v-slot:item.mensaje="{ item }">
                  <div style="max-width: 300px; word-wrap: break-word; white-space: pre-wrap;">
                    {{ item.mensaje || '' }}
                  </div>
                </template>
                <template v-slot:item.acciones="{ item }">
                  <v-btn
                    small
                    color="primary"
                    text
                    @click="asignarAlumnoIndividual( item )"
                    :loading="cargar"
                  >
                    <v-icon small left>mdi-check</v-icon>
                    Acción
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="dialogChats2026 = false">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogComentariosAlumnoChat" max-width="600px" scrollable>
          <v-card v-if="chat && idAlumnoChat">
            <v-card-title class="headline">
              <v-icon small class="mr-2">mdi-chat-multiple</v-icon>
              Comentarios del alumno
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <ComentariosAlumnoChat
                :usuario="chat.usuario"
                :escuela="2"
                :idAlumno="idAlumnoChat"
              />
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="dialogComentariosAlumnoChat = false">
                <v-icon small class="mr-1">mdi-close</v-icon>
                Cerrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <MensajesPredeterminados :openDialogMensajes="openDialogMensajes" v-if="openDialogMensajes.estatus" :alumno="alumno" />
  
        <ReasignarProspecto :dialogReasignar="dialogReasignar" v-if="dialogReasignar.estatus" :alumno="alumno" :wha="wha" :chat="chat" />
  
        <AsignarProspecto :escuela="1" :dialogAsignar="dialogAsignar" v-if="dialogAsignar.estatus" :alumno="alumno" :wha="wha" :chat="chat" />

        <AsignarAlumno 
          :escuela="1" 
          :dialogAsignarAlumno="dialogAsignarAlumno" 
          v-if="dialogAsignarAlumno.estatus" 
          :alumno="alumno"
          :alumnos="alumnos"
          :wha="wha" :chat="chat" 
          :chats="getConversacionesUnifFast"
        />

        <v-dialog v-model="verCodigoZoom" max-width="500px" transition="dialog-transition">
          <v-card v-if="chat">
            <v-card-title class="text-h6 font-weight-regular justify-space-between">
              Código de la clase de zoom
            </v-card-title>
            <v-card-text>
              <v-textarea
                v-model="chat.link_zoom"
                rows="3"
                auto-grow
                readonly

                label="Agregar acceso al zoom"
                filled
              />
            </v-card-text>

            <v-btn icon absolute top right color="black" tile dark small @click="verCodigoZoom = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card>
        </v-dialog>

        <v-dialog v-model="verArchivosPrecargados" max-width="500px" transition="dialog-transition">
          <v-card>
            <v-card-title class="text-h6 font-weight-regular justify-space-between">
              Archivos precargados en el sistema
            </v-card-title>
            <v-card-text>
              <v-list>
                <v-list-item v-for="archivo in archivosPrecargados" :key="archivo.id">
                  {{ archivo.nombre }}
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-dialog>


    <!-- Dialog de carga -->
    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />
  </v-container>
</template>
  <script>
    import { mapGetters, mapActions } from 'vuex'
    
    // Componentes
    import Alerta from '@/components/alertas/Alerta.vue'
    import carga  from '@/components/alertas/carga.vue';
    
    import MensajesWppTwilio        from '@/components/whatsapp/MensajesTwilioWpp.vue';
    import ListaAlumnos             from '@/components/whatsapp/ListaAlumnos.vue';
    import Toolbar                  from '@/components/whatsapp/Toolbar.vue';
    import MensajesPredeterminados  from '@/components/whatsapp/MensajesPredeterminados.vue';
    import ReasignarProspecto       from '@/components/whatsapp/ReasignarProspecto.vue';
    import AsignarProspecto         from '@/components/whatsapp/AsignarProspecto.vue';
    import AsignarAlumno            from '@/components/whatsapp/AsignarAlumno.vue';
    import ComentariosAlumnoChat    from '@/components/ComentariosAlumnoChat.vue';
    import validarErrores           from '@/mixins/validarErrores'
    import mixinWhatsApp            from '@/mixins/mixinWhatsApp'
    import mixinEstatusWha          from '@/mixins/mixinEstatusWha'
    import mixinTwilioWhatsAppLayout from '@/mixins/mixinTwilioWhatsAppLayout'
    import mixinTwilioChatMensajesPaginados from '@/mixins/mixinTwilioChatMensajesPaginados'
    import mixinTwilioChatTiming from '@/mixins/mixinTwilioChatTiming'
    import { esUsuarioTwilioAdmin, esRecepcionTodosPlantelesCrm, restringeCrmAlPlantelRecepcion } from '@/config/twilioUsuariosAdmin'
  
  export default {
    components: {
      Alerta,
      carga,
      MensajesWppTwilio,
      ListaAlumnos,
      Toolbar,
      MensajesPredeterminados,
      ReasignarProspecto,
      AsignarProspecto,
      AsignarAlumno,
      ComentariosAlumnoChat
    },
  
    mixins: [validarErrores, mixinEstatusWha, mixinWhatsApp, mixinTwilioWhatsAppLayout, mixinTwilioChatMensajesPaginados, mixinTwilioChatTiming],
  
  
    data: () => ({
      unificar: true,
      dialogDescrip: false,
      dialogAsignarAlumno: {
        estatus: false
      },
      dialogComentariosAlumnoChat: false, // Dialog para asignar un alumno a un chat
      analysisIA: {},
      buscarPregunta: '',
      buscarActive: false,
  
      // Alertas
      parametros: {
        dialogError: false,
        mensaje: '',
        color: ''
      },
  
      respuestaAlerta: false,
      cargar: false,
  
      usuarios: [],
  
      usuario: null,
      buscarUsuario: '',
      buscarUsuarioActive: true,
      alumno: null,
      url: 'https://escuelakpi.club/kpi/whatsapp-imagenes/',
  
      notSeen: false,
      searchMensaje: '',
      mensajes: [],
      chat: null,
  
      wha: null,
      notResponse: false,
  
      verTodosLosMensajes: 0,
      message: '',
  
      parametrosAsignarVendedora: {
        estatus: false
      },
      asignacion: null,
      conversaciones: [],
      asignados: [],
      loader: true,
  
      sonido: null,
  
      numeroTwilio: "",
  
      offsetTop: 0,
  
      limite: 30,
      tiempoCargaMs: null,
  
      filtroFuego: false,
      filtroSinProspecto: false,
      filtroHielo: false,
      filtroSinProspectoNoInteres:false,
      filtroMensajes: false,
      filtroTiempo: false,
      filtroSinAlumno:false,
  
      filtroVistos: false,
      etapa: 8,
      etiqueta: null,
  
      filtroTiempo: false,
  
      escuela: 1,
      filtroVendedora: null,
  
      openDialogMensajes: {
        estatus: false
      },
  
      dialogReasignar: {
        estatus: false
      },
  
      dialogAsignar: {
        estatus: false
      },
  
      filtroCiudad: 'todas',
      ciudades: [
        { text: 'Todas', value: 'todas' },
        { text: 'CDMX', value: 'cdmx' },
        { text: 'Monterrey', value: 'mty' },
        { text: 'Guadalajara', value: 'gdl' },
        { text: 'Sucursal', value: 'scr' },
      ],
      filtroIncompletos: null,
      opcionesIncompletos: [
        { text: 'Incompletos con interés', value: 'con_interes' },
        { text: 'Incompletos sin interés', value: 'sin_interes' },
        { text: 'Sin incompletos', value: 'sin_incompletos' },
      ],
      twiliosByCities: { 
        "mty": "whatsapp:+5218187047279", 
        "cdmx": "whatsapp:+5215545703336", 
        "gdl": "whatsapp:+5213316971156",
        "fast": "whatsapp:+5218123255321" 
      },
      allChats: [],
      crmTmpProcesado: false,
      accesos: [334, 3015, 32, 1, 718, 1152, 568, 2574, 2556,2230,954,2767,2767,1312,2910],
      vendedoras_plantel: [],
      filtroUsuarioAsignado: 'todas',
      prospectosChats: [],
      planteles: [],
      plantel: null,
      gruposOnline: [],
      alumnos:[],
      grupoOnline: null,
      tablaChats2026: [],
      headersChats2026: [
        { text: 'Número', value: 'numero', sortable: true },
        { text: 'Mensaje', value: 'mensaje', sortable: false },
        { text: 'Matrícula Extraída', value: 'matricula_extraida', sortable: true },
        { text: 'ID Alumno', value: 'id_alumno', sortable: true },
        { text: 'Matrícula', value: 'matricula', sortable: true },
        { text: 'Alumno', value: 'alumno', sortable: true },
        { text: 'Acciones', value: 'acciones', sortable: false, align: 'center' }
      ],
      verCodigoZoom: false,
      verArchivosPrecargados: false,
      archivosPrecargados: [],
      asignaciones:[
        { color: 'green'    , text: 'Twilio asignado' },
        { color: 'secondary', text: 'Sin conversación' },
        { color: 'pink'    , text: 'Sin Asignación' }
      ],
      dialogAsignarAlumno: {
        estatus: false
      }, // Dialog para asignar un alumno a un chat
      dialogChats2026: false,
      chatsCon2026: [],

      filstrosRI:[
        { color: 'green'    , text: 'Alumno RI' },
        { color: 'red', text: 'Alumno no RI' },
      ],
      filtroRi: null,
      plantelesHabiles:[]
    }),
  
    computed: {
      idAlumnoChat () {
        if (!this.chat) return null
        return this.chat.id_alumno || this.chat.idalumno || null
      },
      ...mapGetters('login', ['getdatosUsuarioERPERP']),
      ...mapGetters('twilio', ['getConversacionesUnifFast']),

      plantelesConContactos() {

        if( (!this.accesosBoton && !this.veTodosPlantelesCrm) || this.restringeCrmAlPlantel ){
          return this.planteles.filter( el => this.plantelesHabiles.some( idplantel => idplantel == el.idplantel ) ).map(p => {
            const totalContactos = this.filterChats.filter(c => c.id_plantel == p.idplantel).length
            return {
              ...p,
              texto: `${p.plantel} (${totalContactos})`
            }
          })
        }
        return this.planteles.map(p => {
          const totalContactos = this.filterChats.filter(c => c.id_plantel == p.idplantel).length
          return {
            ...p,
            texto: `${p.plantel} (${totalContactos})`
          }
        })
      },
  
      accesosBoton() {
        
        // Esther, Eduardo, David, Armando, Luis, Ale de la rosa
        return esUsuarioTwilioAdmin(this.getdatosUsuarioERPERP.iderp) || [568, 334, 1, 32, 2556, 1794, 718, 2230, 954, 2767, 1312, 2910, '2910'].includes(this.getdatosUsuarioERPERP.iderp)
  
      },

      veTodosPlantelesCrm() {
        return esRecepcionTodosPlantelesCrm(this.getdatosUsuarioERPERP.iderp)
      },

      restringeCrmAlPlantel() {
        return restringeCrmAlPlantelRecepcion(this.getdatosUsuarioERPERP)
      },
  
      filterChats() {
        let arr = []
  
        let chats = this.getConversacionesUnifFast
  
        // Validar que chats sea un array
        if (!Array.isArray(chats)) {
          return []
        }
  

        if (this.buscarUsuario) {
  
          // Se necesita buscar por matricula, alumno y usuario pero necesitamos quitar acentos y convertir a minúsculas
          // se nececita normalizar la busqueda
          const buscar = this.buscarUsuario.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
          // Tambien se tiene que normalizar la matricula, el alumno y el usuario que está dentro de chats
          chats = chats.filter(el =>(el.matricula && el.matricula.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().match(buscar)) 
            || (el.alumno && el.alumno.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().match(buscar)) 
            || ( el.usuario && el.usuario.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().match(buscar) )
            || ( el.ultimosMensajes && el.ultimosMensajes.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().match(buscar) )
          )
        }
  
        // Orderdenar por fecha, de la más reciente a la más antigua y al final, poner los que no tienen un usuario que es el de twilio
        chats = chats.slice().sort((a, b) => {
          // Si ambos tienen fecha, ordenar por fecha (más reciente primero)
          if( a.fecha_ultimo_mensaje && b.fecha_ultimo_mensaje ){
            return new Date(b.fecha_ultimo_mensaje) - new Date(a.fecha_ultimo_mensaje);
          }
          // Si solo 'a' tiene fecha, 'a' va primero
          if( a.fecha_ultimo_mensaje && !b.fecha_ultimo_mensaje ){
            return -1;
          }
          // Si solo 'b' tiene fecha, 'b' va primero
          if( !a.fecha_ultimo_mensaje && b.fecha_ultimo_mensaje ){
            return 1;
          }
          // Si ninguno tiene fecha, mantener el orden
          return 0;
        });

        if( this.grupoOnline ){
          chats = chats.filter(el => el.id_grupo == this.grupoOnline)
        }

        // Vamos a filtrar por mensajes pendientes de responder
        if (this.filtroVistos) {
  
          chats = chats.filter(el => el.mio == 0)

        }

        if( this.filtroSinAlumno ){

          if( this.filtroSinAlumno.text == 'Twilio asignado' ){
            chats = chats.filter(el => (el.alumno && el.usuario) || (el.alumno && el.usuario_asignado) )
          }

          if( this.filtroSinAlumno.text == 'Sin conversación' ){
            chats = chats.filter(el => !el.usuario && !el.usuario_asignado )
          }
          
          if( this.filtroSinAlumno.text == 'Sin Asignación' ){
            chats = chats.filter(el => !el.alumno )
          }

        }

        if (this.etiqueta) {
  
          chats = chats.filter(el => el.idetiquetas_inscritos == this.etiqueta.idetiquetas_inscritos)

        }

        if( this.plantel ){
          chats = chats.filter(el => el.id_plantel == this.plantel)
        }

        if (this.restringeCrmAlPlantel) {
          chats = chats.filter(el => this.chatCrmPermitido(el))
        }

        if (this.filtroTiempo) {
  
          if (this.filtroTiempo.idtiempos == 1) {
            chats = chats.filter(el => el.tiemporestante > 2)
          } else if (this.filtroTiempo.idtiempos == 2) {
            chats = chats.filter(el => el.tiemporestante > 0 && el.tiemporestante <= 2)
          } else if (this.filtroTiempo.idtiempos == 3) {
            chats = chats.filter(el => el.tiemporestante <= 0)
          }


        }

        if(this.filtroRi){
          if( this.filtroRi.text == 'Alumno no RI' ){
            chats = chats.filter(el => !el.ri)
          }else{
            chats = chats.filter(el => el.ri)
          }
        }

        return chats
  
        // Filtro por ciudad
        if (this.filtroCiudad !== 'todas') {
          chats = chats.filter(el => {
            if (this.filtroCiudad == 'scr') {
              return !['cdmx', 'mty', 'gdl'].includes(el.city)
            } else {
              if (el.city) {
                return el.city == this.filtroCiudad
              }
            }
            return false
          })
        }
  
        // if (this.filtroUsuarioAsignado !== 'todas') {
        //   chats = chats.filter(el => {
        //     if (el.usuario_asignado) {
        //       return el.usuario_asignado == this.filtroUsuarioAsignado
        //     }
        //     return false
        //   })
        // }
  
        if (this.filtroFuego && !this.filtroHielo) {
          chats = chats.filter(el => el.nombre == '🔥')
        }
  
        if (this.filtroMensajes) {
          chats = chats.filter(el => el.totalMensajes >= 4)
        }
  
        if (this.filtroHielo && !this.filtroFuego) {
          chats = chats.filter(el => el.nombre == '🧊')
        }
  
        if (this.etapa && this.etapa != 8) {
  
          chats = chats.filter(el => el.idetapa == this.etapa)
  
        }
  
        
  
        
  
        if( this.filtroIncompletos ){
          if( this.filtroIncompletos == 'con_interes' ){
            chats = chats.filter(el => !el.folio && el.totalMensajes >= 2)
          } else if( this.filtroIncompletos == 'sin_interes' ){
            chats = chats.filter(el => !el.folio && el.totalMensajes  < 2)
          } else if( this.filtroIncompletos == 'sin_incompletos' ){
            chats = chats.filter(el => el.folio )
          }
        }
  
        // if( this.filtroSinProspecto ){
        //   chats = chats.filter(el => !el.folio && el.totalMensajes >= 2)
        // }
  
        // if( this.filtroSinProspectoNoInteres ){
        //   chats = chats.filter(el => !el.folio && el.totalMensajes  < 2)
        // }
  
        if (this.filtroTiempo) {
  
          if (this.filtroTiempo.idtiempos == 1) {
            chats = chats.filter(el => el.tiemporestante > 2)
          } else if (this.filtroTiempo.idtiempos == 2) {
            chats = chats.filter(el => el.tiemporestante > 0 && el.tiemporestante <= 2)
          } else if (this.filtroTiempo.idtiempos == 3) {
            chats = chats.filter(el => el.tiemporestante <= 0)
          }
  
  
        }
        this.conteoEtiquetas(chats)
  
        return chats
      },
  
      filterFiltro() {
  
        let filtro = [
          { id: 2, text: `Nuevo (${this.getConversacionesUnifFast.filter(el => el.idetapa == 2).length})` },
          { id: 1, text: `Atrasado (${this.getConversacionesUnifFast.filter(el => el.idetapa == 1).length})` },
          { id: 4, text: `Con Info (${this.getConversacionesUnifFast.filter(el => el.idetapa == 4).length})` },
          { id: 5, text: `Sin info (${this.getConversacionesUnifFast.filter(el => el.idetapa == 5).length})` },
          { id: 7, text: `2da Contacto (${this.getConversacionesUnifFast.filter(el => el.idetapa == 7).length})` },
          { id: 8, text: `Todos (${this.filterChats.length})` },
        ]
  
        return filtro
      },
  
      filterVendedoras() {
        return this.vendedoras.filter(el => el.escuela == this.escuela)
      },
  
      tamanioPantalla() {
        return this.$vuetify.breakpoint.height - 350
      },
      usuariosAsignados() {
        let list = []
        if (this.vendedorasTwilio && this.vendedorasTwilio.length) {
          list = this.vendedorasTwilio
        } else {
          list = this.vendedoras_plantel
        }
  
        list.forEach(it => {
          if (it.iderp) {
            it.id_usuario_asignado = it.iderp
          }
          if (it.idusuario) {
            it.id_usuario_asignado = it.idusuario
          }
        })
  
        return list
      }
    },
  
    watch: {

      // Filtro por vendedora
      filtroVendedora(value) {
  
        this.initializeAllCities()
  
      },

      getConversacionesC(val) {
        if (val && val.length) {
          val.forEach(it => it.ciudad = "cdmx")
        }
      },
      getConversacionesM(val) {
        if (val && val.length) {
          val.forEach(it => it.ciudad = "mty")
        }
      },
      getConversacionesG(val) {
        if (val && val.length) {
          val.forEach(it => it.ciudad = "gdl")
        }
      },

      getConversacionesUnifFast () {
        this.onStoreChatListUpdated()
      },
    },
  
    async created() {

      // Obtener las vendedoras
      await this.getVendedoras();

      // Obtener los planteles
      await this.getPlanteles();
      
      // Crear el template del sonido
      this.crearTemplateSonido();
    },

    methods: {
      // Acciones de la store twilio
      ...mapActions('twilio', ['guardarConversacionesUnif', 'guardarConversacionesUnifFast']),

      // Función para scroll
      onScroll(e) {
        this.offsetTop = e.target.scrollTop
        this.onScrollMensajesChat(e)
      },

      // Función para obtener el nombre del usuario
      getNombre(texto) {
        return texto.usuario
      },

      // Seleccionar una vendedora
      seleccionaVendedora(item) {
        this.filtroVendedora = item
      },

      // Función para obtener los planteles
      async getPlanteles() {
        const response = await this.$http.get('planteles.all')
        const list = response.data.filter( el => el.plantel.match('FAST') && el.plantel != 'SIN PLANTEL' )
        this.planteles = list.sort((a, b) => a.plantel.localeCompare(b.plantel))
      },

      plantelCrmPermitido(idPlantel) {
        const habiles = Array.isArray(this.plantelesHabiles) && this.plantelesHabiles.length
          ? this.plantelesHabiles
          : [this.getdatosUsuarioERPERP.id_plantel]
        return habiles.some(id => id == idPlantel)
      },

      // Chats sin alumno (ESTOY ONLINE) no tienen plantel: recepción debe verlos para ligarlos a matrícula
      chatCrmPermitido(chat) {
        return !chat.alumno || this.plantelCrmPermitido(chat.id_plantel)
      },
  
      // Función para ver un chat 
      verChat(chat) {

        // Validamos si el usutio no tiene twilio
        if( !chat.usuario ){
          this.validarErrorDirecto('El usuario no tiene whatsapp')
          return
        }
  
        // Obtener el número de Twilio según la ciudad
        let numeroTwilio = ""
        if (chat.city == "cdmx") {
          numeroTwilio = this.twiliosByCities.cdmx
        }
        if (chat.city == "mty") {
          numeroTwilio = this.twiliosByCities.mty
        }
        if (chat.city == "gdl") {
          numeroTwilio = this.twiliosByCities.gdl
        }

        if (chat.city == "fast") {
          numeroTwilio = this.twiliosByCities.fast
        }

        // Asignar el número de Twilio al chat
        this.numeroTwilio = numeroTwilio
        chat.numeroTwilio = numeroTwilio

        // Construir el payload para la petición de los mensajes
        const payload = {
          twilio: numeroTwilio,
          usuario: chat.usuario,
          modo: 'crmalumnos',
          escuela: 2,
          limit: this.MENSAJES_POR_PAGINA,
        }

        this.resetPaginacionMensajes()
        this.mensajesChatActivo = {
          twilio: numeroTwilio,
          usuario: chat.usuario,
          modo: 'crmalumnos',
          escuela: 2,
        }
  
        // Iniciar carga de mensajes sin overlay global
        const listScrollTop = this.beginVerChatScroll()
        this.mensajes = []
  
        const t0Chat = this.iniciarTiempoCargaChat()
        // Hacer la petición de los mensajes
        return this.$http.post('twilio.chats.unico', payload).then(response => {
          this.finalizarTiempoCargaChat(t0Chat)

          // Guardar los mensajes
          this.aplicarRespuestaMensajesChat(response)
          let bloqueo = response.data.bloqueo
          // if (response.data.analysisIA) {
          //   this.analysisIA = response.data.analysisIA
          // }

          // Obtener las conversaciones
          let conversaciones = [...this.allChats];
  
          // Si existe.... cambiar el estatus
          for (const i in conversaciones) {
  
            const { usuario } = conversaciones[i]
  
            if (usuario == chat.usuario) {
  
              conversaciones[i].sinleer = 0
  
            }
  
          }
  
          if (bloqueo) {
            chat.idetiquetas = 6
          }
  
          this.chat = chat
  
          this.guardarConversacionesUnif([])
          this.guardarConversacionesUnifFast(conversaciones)
          this.finishVerChatScroll(listScrollTop)
  
        }).catch(error => {
          this.limpiarTiempoCargaChat()
          this.validarError(error.response.data.message)
          this.failVerChatScroll(listScrollTop)
        })
      },
  
      abrirAjustesMensajes() {
  
        this.openDialogMensajes.estatus = true
      },
  
      processChats() {
        // Validar que this.allChats sea un array antes de procesarlo
        this.conteoEtiquetas(this.allChats)
  
        this.setVendedorAsignado()
  
        this.allChats = this.allChats.sort((a, b) => {
          return new Date(b.fecha_ultimo_mensaje) - new Date(a.fecha_ultimo_mensaje)
        })
  
        this.allChats = this.allChats
        
        this.guardarConversacionesUnif([])
        this.guardarConversacionesUnifFast(this.allChats)
  
      },
      setVendedorAsignado() {
        // Validar que this.allChats sea un array antes de procesarlo
        if (!Array.isArray(this.allChats)) {
          return;
        }
  
        if (this.vendedoras_plantel && this.vendedoras_plantel.length) {
          const ref = this;
          this.allChats.forEach(it => {
            const idUsuarioAsignado = it.usuario_asignado
            const vendedor = ref.vendedoras_plantel.find(vp => vp.iderp == idUsuarioAsignado)
            if (vendedor) {
              vendedor.nombre = this.formatearNombre(vendedor.nombre)
              it.vendedor = vendedor
            }
          })
        }
      },
      formatearNombre(nombreCompleto) {
        if (!nombreCompleto || typeof nombreCompleto !== 'string') {
          return '';
        }
  
        return nombreCompleto
          .trim()                          // quita espacios sobrantes al inicio y final
          .toLowerCase()                   // todo a minúsculas primero
          .split(/\s+/)                    // divide por uno o más espacios
          .map(palabra =>
            palabra.charAt(0).toUpperCase() + palabra.slice(1)
          )
          .join(' ');
      },

      async onlyMyChats() {
        // Limpiar el filtro por vendedora
        this.filtroVendedora = null

        // Obtener las conversaciones
        await this.initializeAllCities()
      },

      async getAllChats() {
        try {

          const payload = {
            idusuario: this.filtroVendedora ? this.filtroVendedora.iderp : this.getdatosUsuarioERPERP.iderp,
            id_usuario: this.getdatosUsuarioERPERP.id_usuario,
            escuela: 1,
            idpuesto: this.getdatosUsuarioERPERP.idpuesto,
            idplantel: this.getdatosUsuarioERPERP.id_plantel,
          }

          const t0 = performance.now()
          const response = await this.$http.post('twilio.chats.crmalumnos.fast', payload)
          this.tiempoCargaMs = Math.round(performance.now() - t0)

          const allChats         = response.data.allChats
          this.gruposOnline      = response.data.gruposOnline
          this.alumnos           = response.data.alumnos
          this.plantelesHabiles  = Array.isArray(response.data.idplantel) ? response.data.idplantel : []

          if (this.restringeCrmAlPlantel) {
            if (!this.plantelesHabiles.length) {
              this.plantelesHabiles = [this.getdatosUsuarioERPERP.id_plantel]
            }
            this.gruposOnline = Array.isArray(this.gruposOnline)
              ? this.gruposOnline.filter(el => this.plantelCrmPermitido(el.id_plantel))
              : []
            if (Array.isArray(this.alumnos)) {
              this.alumnos = this.alumnos.filter(el => this.plantelCrmPermitido(el.id_plantel))
            }
            const chats = Array.isArray(allChats) ? allChats : []
            return chats.filter(el => this.chatCrmPermitido(el))
          }

          // Validar si el usuario es un administrador
  
          if ([1, 334, 3015, 568, 2574, '1', '334', '3015', '568', '2574',2556,'2556',2230,'2230',954,'954',2767,'2767',1312,'1312',2910,'2910'].includes(this.getdatosUsuarioERPERP.iderp)) {
            // Si es administrador, devolver todas las conversaciones
            return allChats
          } else {
            // Si no es administrador, devolver las primeras 800 conversaciones
            return allChats
          }
        } catch (error) {
          this.tiempoCargaMs = null
          return []
        }
      },
      async initializeAllCities(cambioEtiqueta) {

        if (!cambioEtiqueta) {
          this.mensajes = []
        }

        this.cargar = true
        this.tiempoCargaMs = null
  
        const chats = await this.getAllChats()

        // Limpiar el array de conversaciones
        this.allChats = []
  
        // Validar que chats sea un array antes de asignarlo
        if (Array.isArray(chats)) {
          // Asignar las conversaciones al array de conversaciones
          this.allChats = chats
        } else {
          // Limpiar el array de conversaciones
          this.allChats = []
        }
  
        this.cargar = false
        this.processChats()
        this.intentarAbrirCrmAlumnoTmp()
  
      },

      /** Deep-link desde RI Grupos: abre el chat del número (query, localStorage o sessionStorage). */
      intentarAbrirCrmAlumnoTmp() {
        if (this.crmTmpProcesado) return

        const soloDigitos = (v) => String(v || '').replace(/\D/g, '')
        let last10 = null
        let auto = null

        if (this.$route && this.$route.query) {
          if (this.$route.query.crmTel) last10 = this.$route.query.crmTel
          if (this.$route.query.crmAuto) auto = String(this.$route.query.crmAuto)
        }
        if (!last10) {
          try {
            last10 = localStorage.getItem('crmAlumnoTmp')
            auto = localStorage.getItem('crmAlumnoTmpAutoOpen')
          } catch (e) { /* ignore */ }
        }
        if (!last10) {
          last10 = sessionStorage.getItem('crmAlumnoTmp')
          auto = sessionStorage.getItem('crmAlumnoTmpAutoOpen')
        }

        if (!last10 || auto !== '1') return

        const objetivo = soloDigitos(last10).slice(-10)
        if (objetivo.length !== 10) return

        this.buscarUsuario = objetivo

        if (!this.allChats || !this.allChats.length) return

        this.crmTmpProcesado = true
        try {
          localStorage.removeItem('crmAlumnoTmp')
          localStorage.removeItem('crmAlumnoTmpAutoOpen')
        } catch (e) { /* ignore */ }
        sessionStorage.removeItem('crmAlumnoTmp')
        sessionStorage.removeItem('crmAlumnoTmpAutoOpen')

        const chat = (this.allChats || []).find((c) => soloDigitos(c.usuario).slice(-10) === objetivo)
        if (chat) {
          this.verChat(chat)
        } else if (this.validarError) {
          this.validarError('El número quedó ligado, pero el alumno aún no ha enviado mensaje: no hay conversación para abrir todavía.')
        }
      },

      async getUsersChats() {
        this.cargar = true
        try {
          let idusuarios = []
          if (this.vendedorasTwilio && this.vendedorasTwilio.length) {
            idusuarios = this.vendedorasTwilio.map(it => it.iderp)
          } else {
            idusuarios = this.vendedoras_plantel.map(it => it.idusuario)
          }
          idusuarios.push(this.getdatosUsuarioERPERP.id_usuario)
          const payload = {
            idusuarios: idusuarios,
            idusuario: this.getdatosUsuarioERPERP.id_usuario
          }
          const response = await this.$http.post('twilio.chatsMCG.usersGroup', payload)
  
          // Validar que response.data sea un array
          if (response.data && Array.isArray(response.data) && response.data.length) {
            this.allChats = response.data
  
            this.processChats()
          } else {
            this.allChats = []
          }
  
        } catch (error) {
          this.allChats = [] // Asegurar que sea un array vacío en caso de error
        } finally {
          this.cargar = false
        }
      },
      async cerrarContacto(){
        try {
          await this.$http.post('twilio.chat.cerrar.prospecto',{idprospectos:this.chat.idprospectos})
          this.chat = null
          this.initializeAllCities()
          
        } catch (error) {

        }
      },
      enriquecerProspectos(prospectos) {
  
        // 2. Enriquecer cada prospecto
        return prospectos.map(prospecto => {
          const plantel = prospecto.plantel ? prospecto.plantel.replace(/_/g, " ") : 'SIN PLANTEL'
          return {
            "idusuarios_wpp": 76481,
            "usuario": "whatsapp:+521" + prospecto.telefono,
            "nombre": "",
            "deleted": 0,
            "fecha_creacion": prospecto.fecha_creacion,
            "idetiquetas": 12,
            "ReferralSourceId": "",
            "ReferralSourceUrl": "",
            "ProfileName": prospecto.nombreCompleto,
            "ReferralHeadline": "",
            "ReferralCtwaClid": "",
            "ReferralBody": "",
            "mensaje": "El prospecto desea información",
            "mio": 1,
            "type": 1,
            "MediaUrl0": "",
            "color": "#E040FB",
            "totalMensajes": 0,
            "ventanaCerrada": 0,
            "diasSinMovimiento": 0,
            "tiemporestante": 0,
            "fecha_ultimo_mensaje": prospecto.fecha_creacion,
            "existe": true,
            "idprospectos": prospecto.idprospectos,
            "folio": prospecto.folio,
            "idetapa": prospecto.idetapa,
            "reasignado": 0,
            "city": plantel,
            "sucursal": true,
            "usuario_asignado": prospecto.usuario_asignado
          }
        })
      },

      abrirAjustesMensajes() {
        this.openDialogMensajes.estatus = true
      },


      buscarChatsCon2026() {
        // Filtrar chats donde el último mensaje es del usuario (mio = 0) y contiene "2026"
        const chats = this.getConversacionesUnifFast || []
        
        // filtramos los chats que no tienen alumno asignado
        const chatsFiltrados = chats.filter(chat => {
          // Verificar que el último mensaje sea del usuario (mio = 0)
          return chat.twilio_asignado ? false : true

        })
        
        console.log('Chats filtrados:', chatsFiltrados.length)
        
        // Procesar cada chat para extraer matrícula y buscar en alumnos
        this.tablaChats2026 = chatsFiltrados.map(chat => {
          // Extraer matrícula del mensaje o ultimosMensajes (formato 2026-XXXXX)
          let matriculaExtraida = this.extraerMatricula(chat.mensaje)
          
          // Si no se encontró en el mensaje principal, buscar en ultimosMensajes
          if (!matriculaExtraida && chat.ultimosMensajes) {
            matriculaExtraida = this.extraerMatricula(chat.ultimosMensajes)
          }
          
          // Extraer nombre completo del mensaje o ultimosMensajes (si no hay matrícula)
          let nombreExtraido = null
          if (!matriculaExtraida) {
            nombreExtraido = this.extraerNombre(chat.mensaje)
            // Si no se encontró en el mensaje principal, buscar en ultimosMensajes
            if (!nombreExtraido && chat.ultimosMensajes) {
              nombreExtraido = this.extraerNombre(chat.ultimosMensajes)
            }
          }
          
          // Buscar el alumno en el arreglo de alumnos usando la matrícula, id_alumno o nombre
          // Buscar el alumno en el arreglo de alumnos usando la matrícula, id_alumno, nombre o teléfono
          let alumnoEncontrado = null
          if (this.alumnos && this.alumnos.length > 0) {
            // PRIMERO: Buscar por teléfono (twilio_texto) comparando con el usuario del chat
            if (chat.usuario) {

              alumnoEncontrado = this.alumnos.find(al => {
                if( chat.usuario.match(al.twilio_texto ) ){
                  return true
                }
              })

              // Extraer los últimos 10 dígitos del usuario (ej: "whatsapp:+5218180761486" -> "8180761486")
              const soloDigitos = chat.usuario.toString().replace(/\D/g, '')
              const telefonoChat = soloDigitos.length >= 10 ? soloDigitos.slice(-10) : null
              
              if (telefonoChat) {
                alumnoEncontrado = this.alumnos.find(al => {
                  if (!al || !al.twilio_texto) return false
                  // Comparar los 10 dígitos del chat con twilio_texto del alumno
                  const telefonoAlumno = al.twilio_texto.toString().replace(/\D/g, '')
                  const telefonoAlumno10 = telefonoAlumno.length >= 10 ? telefonoAlumno.slice(-10) : telefonoAlumno
                  return telefonoAlumno10 === telefonoChat
                })
                
              }
            }
            
            // SEGUNDO: Si no se encontró por teléfono, buscar por matrícula o id_alumno
            if (!alumnoEncontrado && matriculaExtraida) {
              const matriculaNormalizada = matriculaExtraida.trim()
              
              // Verificar si es un número de 5 dígitos (posible id_alumno)
              const esNumero5Digitos = /^\d{5}$/.test(matriculaNormalizada)
              
              // Si es un número de 5 dígitos, buscar primero por id_alumno
              if (esNumero5Digitos) {
                const idBuscado = parseInt(matriculaNormalizada, 10)
                alumnoEncontrado = this.alumnos.find(al => {
                  if (!al || !al.id_alumno) return false
                  return parseInt(al.id_alumno, 10) === idBuscado
                })
              }
              
              // Si no se encontró por id_alumno, buscar por matrícula completa
              if (!alumnoEncontrado) {
                const matriculaUpper = matriculaNormalizada.toUpperCase()
                alumnoEncontrado = this.alumnos.find(al => {
                  if (!al || !al.matricula) return false
                  return al.matricula.toString().trim().toUpperCase() === matriculaUpper
                })
              }
            }
            
            // TERCERO: Si no se encontró por matrícula/id y hay nombre extraído, buscar por nombre
            if (!alumnoEncontrado && nombreExtraido) {
              alumnoEncontrado = this.buscarAlumnoPorNombre(nombreExtraido)
            }
          }
          
          // Crear el objeto resultante asegurándonos de que las propiedades se asignen correctamente
          const resultado = {
            ...chat,
            matricula_extraida: matriculaExtraida || null,
            id_alumno: alumnoEncontrado ? alumnoEncontrado.id_alumno : null,
            matricula: alumnoEncontrado ? alumnoEncontrado.matricula : null,
            alumno: alumnoEncontrado ? alumnoEncontrado.alumno : null
          }
          
          return resultado
        }).filter(item => {
          // Solo mostrar chats que tienen matrícula extraída Y id_alumno
          return item.matricula_extraida && item.id_alumno
        })
        
        // Ordenar por fecha más reciente primero
        this.tablaChats2026.sort((a, b) => {
          if (a.fecha_ultimo_mensaje && b.fecha_ultimo_mensaje) {
            return new Date(b.fecha_ultimo_mensaje) - new Date(a.fecha_ultimo_mensaje)
          }
          return 0
        })
        
        this.dialogChats2026 = true
      },

      // Método para extraer la matrícula del formato 2026-XXXXX del mensaje
      // Método para extraer la matrícula del formato 2026-XXXXX del mensaje o número de 5 dígitos
      extraerMatricula(mensaje) {
        if (!mensaje) {
          return null
        }
        
        const mensajeStr = mensaje.toString()
        
        // 1. Buscar patrón completo con espacios alrededor del guion: "2026 - 38425" -> "2026-38425"
        const regexConEspacios = /202[1-6]\s*-\s*[A-Z0-9]+/gi
        let match = mensajeStr.match(regexConEspacios)
        
        if (match && match.length > 0) {
          // Limpiar espacios alrededor del guion
          const resultado = match[0].replace(/\s*-\s*/, '-')
          return resultado
        }
        
        // 2. Buscar patrón completo sin espacios: "2026-32342" o "2025-34891"
        const regexSinEspacios = /202[1-6]-[A-Z0-9]+/gi
        match = mensajeStr.match(regexSinEspacios)
        
        if (match && match.length > 0) {
          const resultado = match[0]
          return resultado
        }
        
        // 3. Buscar matrícula sin guion pero con año completo: "202638646" -> "2026-38646"
        const regexSinGuion = /(202[1-6])(\d{5})/gi
        match = mensajeStr.match(regexSinGuion)
        
        if (match && match.length > 0) {
          // Reconstruir con guion: "202638646" -> "2026-38646"
          const año = match[0].substring(0, 4)
          const numero = match[0].substring(4)
          const resultado = `${año}-${numero}`
          return resultado
        }
        
        // 4. Buscar formato con año corto: "25-25944" -> "2025-25944"
        const regexAnioCorto = /\b(\d{2})-(\d{5})\b/g
        match = mensajeStr.match(regexAnioCorto)
        
        if (match && match.length > 0) {
          const partes = match[0].split('-')
          const añoCorto = partes[0]
          const numero = partes[1]
          // Convertir año corto a año completo (asumiendo 20XX)
          const añoCompleto = `20${añoCorto}`
          const resultado = `${añoCompleto}-${numero}`
          return resultado
        }
        
        // 5. Buscar después de "Matricula:" o "Matrícula:" con formato completo
        // Ejemplo: "Matricula: 2026-38407" o "Matrícula 202638646"
        const regexMatriculaCompleta = /(?:matricula|matrícula)[\s:]*(\d{4,9})/gi
        match = mensajeStr.match(regexMatriculaCompleta)
        
        if (match && match.length > 0) {
          const numeroMatch = match[0].match(/\d{4,9}/)
          if (numeroMatch) {
            const numero = numeroMatch[0]
            // Si tiene 9 dígitos, separar año y número
            if (numero.length === 9 && numero.startsWith('202')) {
              const año = numero.substring(0, 4)
              const num = numero.substring(4)
              const resultado = `${año}-${num}`
              return resultado
            }
            // Si tiene formato con guion, ya está bien
            if (numero.includes('-')) {
              return numero
            }
            // Si son 5 dígitos, devolverlos tal cual
            if (numero.length === 5) {
              return numero
            }
          }
        }
        
        // 6. Buscar números de 5 dígitos solos (al final del mensaje o en cualquier parte)
        // Ejemplo: "Dulce Mariana Acevedo Hernández 37735" o "Evelyn Paola Olvera Martínez 27885"
        const regexSoloNumeros = /\b(\d{5})\b/g
        match = mensajeStr.match(regexSoloNumeros)
        
        if (match && match.length > 0) {
          // Tomar el último número de 5 dígitos encontrado (probablemente al final)
          const resultado = match[match.length - 1]
          return resultado
        }
        
        return null
      },

      // Método para extraer nombre completo del mensaje
      extraerNombre(mensaje) {
        if (!mensaje) return null
        
        const mensajeStr = mensaje.toString().trim()
        
        // Remover palabras comunes al inicio
        const sinSaludos = mensajeStr
          .replace(/^(hola|buenos|buenas|días|día|tardes|noches|saludos|estimado|estimada)[\s,]*/i, '')
          .trim()
        
        // Buscar patrones de nombre completo (2-4 palabras seguidas, empezando con mayúscula)
        // Ejemplo: "Hassiel Alejandro Lucio Sauceda" o "Jorge Asael Canizales Trujillo"
        const regexNombre = /^([A-ZÁÉÍÓÚÑ][a-záéíóúñ]+(?:\s+[A-ZÁÉÍÓÚÑ][a-záéíóúñ]+){1,3})(?:\s|$|,|:|\d|matricula|matrícula)/i
        const match = sinSaludos.match(regexNombre)
        
        if (match && match[1]) {
          const nombre = match[1].trim()
          return nombre
        }
        
        // Si no se encuentra con el patrón anterior, intentar tomar las primeras 2-4 palabras
        const palabras = sinSaludos.split(/\s+/).filter(p => p.length > 0)
        if (palabras.length >= 2 && palabras.length <= 4) {
          // Verificar que las primeras palabras empiecen con mayúscula
          const todasMayuscula = palabras.every(p => /^[A-ZÁÉÍÓÚÑ]/.test(p))
          if (todasMayuscula) {
            const nombre = palabras.join(' ')
            return nombre
          }
        }
        
        return null
      },

      // Método para buscar alumno por nombre completo
      buscarAlumnoPorNombre(nombreBuscado) {
        if (!nombreBuscado || !this.alumnos || this.alumnos.length === 0) return null
        
        // Normalizar el nombre buscado: quitar acentos, convertir a mayúsculas, quitar espacios extra
        const normalizar = (texto) => {
          return texto
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '') // Quitar acentos
            .toUpperCase()
            .trim()
            .replace(/\s+/g, ' ') // Normalizar espacios
        }
        
        const nombreNormalizado = normalizar(nombreBuscado)
        
        // Buscar coincidencia exacta
        let alumno = this.alumnos.find(al => {
          if (!al || !al.alumno) return false
          return normalizar(al.alumno) === nombreNormalizado
        })
        
        if (alumno) return alumno
        
        // Buscar coincidencia parcial (el nombre buscado contiene el nombre del alumno o viceversa)
        alumno = this.alumnos.find(al => {
          if (!al || !al.alumno) return false
          const alumnoNormalizado = normalizar(al.alumno)
          
          // Verificar si el nombre buscado contiene el nombre del alumno o viceversa
          return nombreNormalizado.includes(alumnoNormalizado) || 
                alumnoNormalizado.includes(nombreNormalizado)
        })
        
        if (alumno) return alumno
        
        // Buscar por palabras clave (al menos 2 palabras coinciden)
        const palabrasBuscadas = nombreNormalizado.split(' ').filter(p => p.length > 2)
        if (palabrasBuscadas.length >= 2) {
          alumno = this.alumnos.find(al => {
            if (!al || !al.alumno) return false
            const alumnoNormalizado = normalizar(al.alumno)
            const palabrasAlumno = alumnoNormalizado.split(' ')
            
            // Contar cuántas palabras coinciden
            const coincidencias = palabrasBuscadas.filter(pb => 
              palabrasAlumno.some(pa => pa.includes(pb) || pb.includes(pa))
            )
            
            return coincidencias.length >= 2
          })
        }
        
        return alumno || null
      },

      // Método para asignar todos los alumnos de manera masiva

      // Método para asignar todos los alumnos de manera masiva
            // Método para asignar todos los alumnos de manera masiva
      async asignarTodos2026() {
        if (!this.tablaChats2026 || this.tablaChats2026.length === 0) {
          this.validarError('No hay chats para asignar')
          return
        }

        this.cargar = true
        let asignacionesExitosas = 0
        let asignacionesFallidas = 0

        try {
          // Hacer un ciclo sobre todos los chats de la tabla
          for (const item of this.tablaChats2026) {
            if (!item.id_alumno || !item.usuario) {
              asignacionesFallidas++
              continue
            }

            const payload = {
              idalumno: item.id_alumno,
              twilio_asignado: item.usuario
            }

            try {
              await this.$http.post('asignacion.alumno.whatsapp', payload)
              asignacionesExitosas++
            } catch (error) {
              asignacionesFallidas++
              console.error('Error al asignar chat:', item.usuario, error)
            }
          }

          // Inicializar el componente de nuevo
          await this.initializeAllCities()

          // Cerrar el diálogo
          this.dialogChats2026 = false

          // Mostrar mensaje de éxito
          if (asignacionesExitosas > 0) {
            this.validarSuccess(
              `Se asignaron correctamente ${asignacionesExitosas} chat${asignacionesExitosas > 1 ? 's' : ''}`
            )
          }

          if (asignacionesFallidas > 0) {
            this.validarError(
              `${asignacionesFallidas} asignación${asignacionesFallidas > 1 ? 'es' : ''} fallaron`
            )
          }
        } catch (error) {
          this.validarError('Error al realizar la asignación masiva')
        } finally {
          this.cargar = false
        }
      },

      // Método para asignar un alumno individualmente
      async asignarAlumnoIndividual(item) {
        if (!item.id_alumno || !item.usuario) {
          this.validarError('El chat no tiene los datos necesarios para asignar')
          return
        }

        this.cargar = true

        try {
          const payload = {
            idalumno: item.id_alumno,
            twilio_asignado: item.usuario
          }

          await this.$http.post('asignacion.alumno.whatsapp', payload)

          // Actualizar el chat si está abierto
          if (this.chat && this.chat.usuario === item.usuario) {
            this.chat['alumno'] = item.alumno
            this.chat['id_alumno'] = item.id_alumno
          }

          // Inicializar el componente de nuevo
          await this.initializeAllCities()

          this.validarSuccess('Alumno asignado correctamente')
        } catch (error) {
          this.validarError( error.response.data.message )
        } finally {
          this.cargar = false
        }
      },
    },
  }
  </script>

<style scoped lang="scss">
@import '@/assets/styles/twilio-whatsapp-layout.scss';

.textoPoppins {
  font-family: 'Poppins', sans-serif !important;
}

.twilio-whatsapp-shell.container {
  height: calc(100vh - 64px) !important;
  height: calc(100dvh - 64px - env(safe-area-inset-top, 0px)) !important;
  min-height: 0 !important;
  margin-top: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

.twilio-whatsapp-shell #scroll-target.container,
.twilio-whatsapp-shell .wa-messages-scroll.container {
  height: 100% !important;
  min-height: 0 !important;
  margin-top: 0 !important;
  background-color: transparent !important;
  box-shadow: none !important;
}
</style>
